import React from 'react'

import { useTheme } from '@mui/material'

import Badge from 'components_new/atoms/Badge'
import Box from 'components_new/atoms/Box'
import Icon, { IconName } from 'components_new/atoms/Icon'
import Tooltip from 'components_new/atoms/Tooltip'

interface FixedSideButtonProps {
  badge?: boolean
  iconName: IconName
  onClick: () => void
  tooltip?: string
  top?: number
}

const FixedSideButton = (props: FixedSideButtonProps) => {
  const { badge = false, iconName, onClick, tooltip, top = 8 } = props

  const theme = useTheme()

  return (
    <Tooltip title={tooltip}>
      <Box
        sx={{
          position: 'absolute',
          right: 0,
          top,
          overflow: 'hidden',
          zIndex: theme.zIndex.drawer
        }}
      >
        <Box
          onClick={onClick}
          sx={{
            alignItems: 'center',
            bgcolor: 'background.paper',
            borderTopLeftRadius: 16,
            borderBottomLeftRadius: 16,
            border: '1px solid',
            borderColor: 'divider',
            cursor: 'pointer',
            display: 'flex',
            height: 32,
            justifyContent: 'flex-start',
            pl: 0.5,
            transition: 'transform 0.25s',
            transitionTimingFunction: theme.transitions.easing.easeInOut,
            transform: 'translateX(16px)',
            width: 40,
            '&:hover': {
              transform: 'translateX(0px)'
            }
          }}
        >
          <Badge
            anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
            color="primary"
            variant="dot"
            invisible={!badge}
          >
            <Icon fontSize="small" name={iconName} />
          </Badge>
        </Box>
      </Box>
    </Tooltip>
  )
}

export default FixedSideButton
